export const IS_BANNER_ENABLED_DEFAULT = false;
//# sourceMappingURL=banner.js.map